import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-body-becario',
  templateUrl: './body-becario.component.html',
  styleUrls: ['./body-becario.component.css']
})
export class BodyBecarioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
